<template>
<v-layout column>
    <v-flex v-for="(attribute, j) in items" :key="j" xs12 pa-3>
        <v-toolbar color="grey" class="white--text" flat dense height="45px">
            <v-btn v-if="!attribute.AttributeMandatory" icon color="error" @click="handleDeleteAttribute(attribute)">
                <v-icon>delete</v-icon>
            </v-btn>
            <v-toolbar-title class="body-2 white--text" style="margin-left:5px">
                <span>{{ attribute.AttributeName }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>            
        </v-toolbar>
        <v-data-table :items="attribute.Values" :headers="headers" hide-actions :pagination.sync="pagination[j]">
            <template v-slot:headers="{ headers }">
                <tr style="background:rgb(235, 237, 239)">
                    <th
                    v-for="header in headers"
                    :key="header.text"
                    :class="['column sortable', pagination[j].descending ? 'desc' : 'asc', header.value === pagination[j].sortBy ? 'active' : '']"
                    @click="changeSort(header.sortable, header.value, j)"
                    >
                    <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                    {{ header.text }}
                    </th>
                    <th class="column">
                        <v-btn icon color="primary" @click="addEditAttributeValue({ AttributeID: attribute.AttributeID, CropVarietyID: cropVariety.CropVarietyID, StartDate: cropVariety.PlantingDate || crop.StartDate, EndDate: crop.EndDate })">
                            <v-icon>add</v-icon>
                        </v-btn>
                    </th>
                </tr>
            </template>
            <template v-slot:items="{ item }">   
                <td>
                    <v-checkbox v-if="showCheckbox" :input-value="item.checked" v-model="item.checked" @change="addSelectedAttributes(item)" color="success" hide-details></v-checkbox>
                </td>
                <td>{{ getAttributeValue(item) }}</td>
                <td>{{ formatDate(item.StartDate) }}</td>
                <td>{{ formatDate(item.EndDate) }}</td>
                <td>
                    <v-btn icon color="primary" @click="addEditAttributeValue(item)">
                        <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn icon color="error" @click="handleDeleteAttributeValue(item)">
                        <v-icon>delete</v-icon>
                    </v-btn>
                </td>
            </template>
            <template v-slot:no-data v-if="attribute.AttributeMandatory">
                <td colspan="4" style="padding:0px">
                    <v-alert class="ma-0" outline :value="true" color="error" icon="warning">
                        At least one value is required
                    </v-alert>
                </td>
            </template>
        </v-data-table>
    </v-flex>
    <delete-dialog :DisplayDialog="showConfirmDelete" :DialogTitle="'Delete Item'" :DialogContents="'Are you sure you wish to delete this entry?'" @No="showConfirmDelete = false" @Yes="confirmDelete"></delete-dialog>
    <v-dialog :value="showEditCropVarietyAttribute" max-width="500px" persistent @keydown.esc="handleAttributeValueCancel">
        <crop-variety-attribute-edit v-if="showEditCropVarietyAttribute" :item="cropVarietyAttributeEditData" :productTypeID="crop.ProductTypeID" :submitError="error" @submit="handleAttributeValueSubmit" @cancel="handleAttributeValueCancel">
        </crop-variety-attribute-edit>
    </v-dialog>

</v-layout>
</template>

<script>
import UtilService from '@/services/utilService.js';
import CropVarietyAttributeEdit from '@/components/crops/CropVarietyAttributeEdit.vue';
import DeleteDialog from '@/components/generic/YesNoPopup.vue';



export default {
    components: {
        CropVarietyAttributeEdit: CropVarietyAttributeEdit,
        DeleteDialog: DeleteDialog,
        
    },
    props: {
        crop: {
            required: true,
            type: Object
        },
        cropVariety: {
            required: true,
            type: Object
        },
        mandatory: {
            required: true,
            type: Boolean
        },
        showCheckbox: {
            required: false,
            type: Boolean
        },
        selectAll: {
            required:false,
            type: Boolean
        },
        optional:{
            required:false,
            type:Boolean
        }
    },
    data() {
        return {            
            index: 0,
            error: null,
            showEditCropVarietyAttribute: false,
            cropVarietyAttributeEditData: null,
            deleteItem: null,
            items:null,
            checkboxes:[],
            selectedAttributes:[],
            showConfirmDelete: false,
            pagination: this.cropVariety.Attributes.filter(a => a.AttributeMandatory == this.mandatory).map(() => { return { sortBy: "StartDate", rowsPerPage: -1 }}),
            headers: [
                {
                    text: "",
                    value: "",
                    sortable: false,
                },
                {
                    text: "Value",
                    value: "AttributeValueID",
                    sortable: false
                },
                {
                    text: "Date From",
                    value: "StartDate",
                    sortable: true
                },
                {
                    text: "Date To",
                    value: "EndDate",
                    sortable: true
                }
            ]
        }
    },
    computed: {
        attributes() {
            return this.cropVariety.Attributes.filter(a => a.AttributeMandatory == this.mandatory);
        }
    },
    watch: {
        selectAll: function (){
            if(this.selectAll == true){
                this.selecteAllAttributes();
            }
            else{
                this.resetCheckboxState();
            }
        },
        attributes() {
            this.items = this.attributes;
        }
    },
    methods: {
        changeSort (sortable, column, index) {
            if (sortable) {
                if (this.pagination[index].sortBy === column) {
                    this.pagination[index].descending = !this.pagination[index].descending
                } else {
                    this.pagination[index].sortBy = column
                    this.pagination[index].descending = false
                }
            }
        },
        formatDate(v) {
            if (v) {
                return UtilService.formatDateDMY(v, '/');
            }

            return null;
        },
        formatDateYMD(v) {
            if(v) {
                return UtilService.formatDateYMD(v);
            }
            return null;
        },
        getAttributeValue(item) {
            let result = '';

            let attributeValues = this.$store.getters["CropStore/getAttributeValues"](item.AttributeID);
            let value = attributeValues.find(a => a.AttributeValueID === item.AttributeValueID);

            if (value.UserDefinedValue) {
                result = item.UserDefinedValue;
            } else {
                result = value.Name;
            }

            return result;
        },
        addEditAttributeValue(attributeValue) {
            if (!attributeValue.CropVarietyAttributeID) {
                let newID = -1;
                
                for (const attribute of this.items) {
                    newID -= attribute.Values.filter(v => v.CropVarietyAttributeID < 0).length;
                    if(attribute.Values.length > 0 && attribute.AttributeID==attributeValue.AttributeID){
                        const attributeLength = attribute.Values.length-1;
                        if(this.items.length == 0){
                            attributeValue.StartDate =  this.formatDateYMD(this.cropVariety.PlantingDate);
                        }
                        else if(this.crop.endDateChanged == true && this.items.length > 0){
                            const endDate = new Date(attribute.Values[attributeLength].EndDate);
                            attributeValue.StartDate = this.formatDateYMD(endDate.setDate(endDate.getDate()+1));
                        }else{
                            const endDate = new Date(attribute.Values[attributeLength].EndDate);
                            attributeValue.StartDate = this.formatDateYMD(endDate.setDate(endDate.getDate()+1));
                        }
                    }
                }

                attributeValue.CropVarietyAttributeID = newID;
            }
            this.cropVarietyAttributeEditData = attributeValue;
            this.cropVarietyAttributeEditData.PlantingDate = this.formatDateYMD(this.cropVariety.PlantingDate);
            this.cropVarietyAttributeEditData.CropEndDate = this.formatDateYMD(this.crop.EndDate);
            this.showEditCropVarietyAttribute = true;
        },
        handleDeleteAttribute(item) {
            this.deleteItem = item;
            this.showConfirmDelete = true;
        },
        handleDeleteAttributeValue(item) {
            this.deleteItem = item;
            this.showConfirmDelete = true;
        },
        handleAttributeValueSubmit(item) {
            if(item.StartDate > item.EndDate){
                this.error = "Date from must occur before Date to";
            }
            else{
                this.error = null;
                this.showEditCropVarietyAttribute = false;
            }
            
            let attribute = this.cropVariety.Attributes.find(a => a.AttributeID === item.AttributeID);

            let index = attribute.Values.findIndex(a => a.CropVarietyAttributeID === item.CropVarietyAttributeID);

            if (index >= 0) {
                attribute.Values.splice(index, 1, item);
            } else {
                attribute.Values.push(item);
            }
        },
        handleAttributeValueCancel() {
            this.showEditCropVarietyAttribute = false;
        },
        confirmDelete() {
            let attribute = this.cropVariety.Attributes.find(a => a.AttributeID === this.deleteItem.AttributeID);
            let index = attribute.Values.indexOf(this.deleteItem);
            
            if (index > -1) {            
                attribute.Values.splice(index, 1);
            } else {
                index = this.cropVariety.Attributes.indexOf(this.deleteItem);
                this.cropVariety.Attributes.splice(index, 1);
            }

            this.showConfirmDelete = false;
        },
        addSelectedAttributes(item){
            item.CropVarietyID = this.cropVariety.CropVarietyID;
            this.selectedAttributes.push(item);
            if(item.checked){
                this.$emit("add",item);
            }
            if(!item.checked){
                this.$emit("remove",item);
            }
        },
        selecteAllAttributes(){
            this.$nextTick(() => {
                const newItems = this.items.map(attribute=>{
                attribute.Values.map(value=>{
                    value.checked = true;
                    this.addSelectedAttributes(value);
                    return value;               
                })

                return attribute;
            })
                this.items = newItems;
                
            });
        },
        resetCheckboxState(){
            this.$nextTick(() => {
                const newItems = this.items.map(attribute=>{
                attribute.Values.map(value=>{
                    value.checked = false;
                    this.addSelectedAttributes(value);
                    return value;               
                })

                return attribute;
            })

                this.items = newItems;
            });
        },
        calculateEarliestPlantingDate() {
            const variety = this.crop.CropVarieties.reduce((a,b)=>{
                return a.PlantingDate < b.PlantingDate ? a : b;
            })
            this.crop.PlantingDate = variety.PlantingDate; 
        },
    },
    created: function(){
                this.items = this.attributes;
    },
    beforeDestroy: function() {
        this.resetCheckboxState();
        this.calculateEarliestPlantingDate();
    }
}
</script>
